// @flow
import React, { useState } from 'react';
import { AccordionsList } from '@presentational/accordions/AccordionsList';
import { YearSelectionContext } from '@components/cluster/YearSelectionContext';
import {
  getAccordianPanelDetailsObject,
  getNumberOfYearsBasedOnMonths,
} from '@src/common-utils/utils';
import { SPTableFlowWorkloadResourceDetailsContainer } from '@streaming-projects/workloads/tableflow-workloads/resource-details/SPTableflowWorkloadResourceDetailsContainer';
import { SPTableFlowWorkloadMonthlyUsageContainer } from '@streaming-projects/workloads/tableflow-workloads/monthly-inputs/SPTableFlowWorkloadMonthlyUsageContainer';

import { useSPTableFlowContext } from './contexts/SPTableFlowWorkloadContextProvider';
import { SPTableFlowWorkloadDetailsContainer } from './workload-details/SPTableflowWorkloadDetailsContainer';

export const SPTableFlowWorkloadAccordionsContainer = () => {
  const spTableFlowWorkloadData = useSPTableFlowContext();
  const totalYears = getNumberOfYearsBasedOnMonths(
    spTableFlowWorkloadData.tableflow_details.inputs.length
  );

  const [selectedYear, setSelectedYear] = useState(1);

  const accordionPanels = [
    getAccordianPanelDetailsObject(
      'Workload Specific Details',
      <SPTableFlowWorkloadDetailsContainer />
    ),
    getAccordianPanelDetailsObject(
      'Resource Details',
      <SPTableFlowWorkloadResourceDetailsContainer />
    ),
    getAccordianPanelDetailsObject('Usage Details', <SPTableFlowWorkloadMonthlyUsageContainer />),
  ];

  return (
    <YearSelectionContext.Provider
      value={{
        totalYears,
        selectedYear,
        setSelectedYear,
      }}
    >
      <AccordionsList panels={accordionPanels} />
    </YearSelectionContext.Provider>
  );
};
